export default {
  // list
  'base_port.query.name': '港口名称',
  'base_port.query.name.placeholder': '请输入港口名称',
  'base_port.column.name': '港口名称',
  'base_port.column.createTime': '创建时间',
  'base_port.column.updateTime': '更新时间',
  // edit
  'base_port.edit.title': '编辑港口',
  'base_port.add.title': '新增港口',
  'base_port.edit.success': '编辑成功',
  'base_port.add.success': '新增成功',
  'base_port.form.name.required': '港口名称不能为空',
  'base_port.form.name': '港口名称',
  'base_port.form.name.placeholder': '请输入港口名称',
}
